import { render, staticRenderFns } from "./DepartmentManagement.vue?vue&type=template&id=54c62a6c"
import script from "./DepartmentManagement.vue?vue&type=script&lang=js"
export * from "./DepartmentManagement.vue?vue&type=script&lang=js"
import style0 from "./DepartmentManagement.vue?vue&type=style&index=0&id=54c62a6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports